import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../utils/API_URL";

const initialState = {
  ganttData: [],
  plannerResult: {},
  clickedTask: {},
  work_day: {},
  holiday: [],
  loading: "",
  work_hour: [],
  tem_work_hour: {},
  day_off: [],
};

export const fetchWorkDay = createAsyncThunk(
  "planner/fetchWorkDay",
  async () => {
    const { data } = await axios.get(API_URL + "/getWorkDay");
    return data.work_day[0];
  }
);

export const fetchHoliday = createAsyncThunk(
  "planner/fetchHoliday",
  async () => {
    const { data } = await axios.get(API_URL + "/getHoliday");
    return data.holiday.map(
      (item) => item.holiday.replace("T", " ").slice(0, 10) + " 00:00:00"
    );
  }
);

export const fetchWorkHour = createAsyncThunk(
  "planner/fetchWorkHour",
  async () => {
    const { data } = await axios.get(API_URL + "/getWorkHour");
    return data.work_hour.filter((item) => item.selected === "1");
  }
);

export const fetchTempWorkHour = createAsyncThunk(
  "planner/fetchTempWorkHour",
  async () => {
    const { data } = await axios.get(API_URL + "/getSelectedWorkHour");
    const tem_work_hour = data.selectedWorkHour;
    const workStartMinutes = Number(tem_work_hour[0].start_date.slice(3, 2));
    const workEndMinutes = tem_work_hour.length
      ? Number(tem_work_hour[tem_work_hour.length - 1].end_date.slice(3, 2))
      : Number(tem_work_hour[0].end_date.slice(3, 2));
    const lunchStartMinutes = [];
    const lunchEndMinutes = [];
    const lunchStartHour = [];
    const lunchEndHour = [];
    const workStartHour = Number(tem_work_hour[0].start_date.slice(0, 2));
    const workEndHour = tem_work_hour.length
      ? Number(tem_work_hour[tem_work_hour.length - 1].end_date.slice(0, 2))
      : Number(tem_work_hour[0].end_date.slice(0, 2));
    for (let i = 0; i < tem_work_hour.length - 1; i++) {
      lunchStartHour.push(Number(tem_work_hour[i].end_date.slice(0, 2)));
      lunchStartMinutes.push(Number(tem_work_hour[i].end_date.slice(3, 2)));
      if (tem_work_hour[i + 1].start_date !== undefined) {
        lunchEndHour.push(Number(tem_work_hour[i + 1].start_date.slice(0, 2)));
        lunchEndMinutes.push(
          Number(tem_work_hour[i + 1].start_date.slice(3, 2))
        );
      }
    }
    return {
      workStartMinutes,
      workEndMinutes,
      workStartHour,
      workEndHour,
      lunchStartMinutes,
      lunchEndMinutes,
      lunchStartHour,
      lunchEndHour,
    };
  }
);
export const fetchDayOff = createAsyncThunk("planner/fetchDayOff", async () => {
  const res = await axios.get(API_URL + "/getDayOff");
  return Object.entries(res.data[0][0])
    .map(([key, value]) => ({
      key,
      value,
    }))
    .filter((item) => item.key !== "log_id" && item.key !== "update_time");
});
export const plannerSlice = createSlice({
  name: "planner",
  initialState,
  reducers: {
    setGanttData: (state, action) => {
      state.ganttData = action.payload;
    },
    setPlannerResult: (state, action) => {
      state.plannerResult = action.payload;
    },
    setClickedTask: (state, action) => {
      state.clickedTask = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkDay.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(fetchWorkDay.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.work_day = action.payload;
      })
      .addCase(fetchWorkDay.rejected, (state) => {
        state.loading = "rejected";
      })
      .addCase(fetchHoliday.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(fetchHoliday.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.holiday = action.payload;
      })
      .addCase(fetchHoliday.rejected, (state) => {
        state.loading = "rejected";
      })
      .addCase(fetchWorkHour.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(fetchWorkHour.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.work_hour = action.payload;
      })
      .addCase(fetchWorkHour.rejected, (state) => {
        state.loading = "rejected";
      })
      .addCase(fetchTempWorkHour.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(fetchTempWorkHour.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.tem_work_hour = action.payload;
      })
      .addCase(fetchTempWorkHour.rejected, (state, payload) => {
        state.loading = "rejected";
      })
      .addCase(fetchDayOff.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(fetchDayOff.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.day_off = action.payload;
      })
      .addCase(fetchDayOff.rejected, (state, payload) => {
        state.loading = "rejected";
      });
  },
});

export const { setGanttData, setPlannerResult, setClickedTask } =
  plannerSlice.actions;
export default plannerSlice.reducer;
